module.exports = __webpack_public_path__ + "img/SLG-alt.f5526ffc.svg";